import React from 'react'
import HomeButton from './HomeButton'
import ButtonBack from './ButtonBack'

function NavigationButtonTop({
   setShowComfirmationModal,
   isConfirmationModal,
   isButtonBack,
   setView
}) {
   return (
      <div
         style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2rem',
            alignItems: 'center'
         }}
      >
         <HomeButton
            setShowComfirmationModal={setShowComfirmationModal}
            isConfirmationModal={isConfirmationModal}
         />
         {isButtonBack ? <ButtonBack setView={setView} /> : <div />}
      </div>
   )
}

export default NavigationButtonTop
